<template>
  <div class="hello" style="background-color:#f4f5f5; height:100%; padding-bottom: 50px;">
    <van-sticky class="item-pop">
      <div style="position: relative; max-width: 640px; left:auto; margin: 0 auto;">
        <van-nav-bar style="height:54px;background: rgb(53, 120, 229)" :border="false" @click-left="gotohome" safe-area-inset-top>
          <template #left>
            <van-icon style=" margin-top:10px; font-weight: 900;" name="arrow-left" color="#FFFFFF" size="25"/>
          </template>
          <template #title>
            <div style="width:70%;position: absolute; left:50px; top: 0;">
              <form action="">
                <van-search
                  v-model="title"
                  shape="round"
                  width="200px"
                  background="rgb(53, 120, 229)"
                  placeholder="請輸入搜尋關鍵詞"
                  @search="onSearch()"
                />
              </form>
            </div>
          </template>
          <template #right>
            <van-badge style=" margin-top:10px;" :content="cartItemNum">
              <div class="child">
              <van-icon name="cart" color="#FFFFFF" size="28" @click="gotocart"/>
              </div>
            </van-badge>
          </template>
        </van-nav-bar>
      </div>
    </van-sticky>
    <van-tabs v-model="active" animated color="rgb(53, 120, 229)" swipeable @change="changeType">
      <van-tab title="上架時間" name="1"></van-tab>
      <van-tab title="售出數量" name="2"></van-tab>
    </van-tabs>
    <van-empty
      v-if="items.length === 0"
      description="暫無商品，請看看其它商品吧~"
    />
    <van-cell v-else class="recomm-cell" :border="false" size="large">
        <van-grid :column-num="2" clickable :border="false" >
          <van-grid-item v-for="(item,index) in items" :key="index" @click="gotoItem(item.ShortLink)">
            <div style="width:100%; height: 10rem;">
              <van-image width="100%" height="100%" :src="item.banner" fit="fill"/>
            </div>
            <div style="height:40px; display:inline">
              <p style="float:left;  font-size:0.5rem;font-weight:900; line-height: 0.6rem; ">{{ item.ItemTitle }}</p>
            </div>
            <div style="width:100%;height:20px;">
              <span style="float:left; font-size:0.7rem; font-weight:900;color: #3578e5;">{{ item.Currency }}${{ item.Price }}起</span>
              <span style="float:right; font-size:0.7rem;color: gray;">售出：{{ item.sales }}</span>
            </div>
          </van-grid-item>
        </van-grid>
      </van-cell>
      <div style="margin:0 auto; text-align:center; padding-bottom: 80px;">
        <span style="color: #606266; font-size:0.6rem;">@小泉士多 KOIZUMISHOP</span>
      <div style="margin-top:20px;">
        <ul style="display: inline-flex;list-style: none;"><li style="margin-right: 14px;"><a style="color:#606266; text-decoration: none;font-size:0.6rem;" href="/privacy">隱私政策</a></li><li><a style="color:#606266; text-decoration: none;font-size:0.6rem;" href="/terms">服務條款</a></li></ul>
      </div>
    </div>
  </div>
</template>
<script>
import { searchItem } from '@/api/item'
import { Toast } from 'vant'
import cart from '@/utils/cart'

export default {
  name: '',
  data () {
    return {
      title: '',
      items: [],
      active: 1,
      cartItemNum: cart.cartItemNum
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        this.title = route.query.name
      },
      immediate: true
    }
  },
  created () {
    this.onSearchItem(1)
  },
  methods: {
    goback () {
      this.$router.back(-1)
      window.scrollTo(0, 0)
    },
    onSearch () {
      this.$router.replace({path: '/result', query: {name: this.title}})
      this.onSearchItem(this.active)
    },
    onSearchItem (itype) {
      Toast.loading({
        message: '加載中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 3000
      })
      searchItem({ name: this.title, type: itype }).then(res => {
        if (res.code === 200) {
          this.items = []
          this.items = res.data
          Toast.clear()
        } else {
          Toast.fail('加載出錯，請刷新重試')
        }
      })
    },
    gotohome () {
      this.$router.back(-1)
      window.scrollTo(0, 0)
    },
    gotoItem (link) {
      window.scrollTo(0, 0)
      this.$router.push({ path: '/' + link })
      Toast.loading({
        message: '加載中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 200
      })
    },
    changeType (e) {
      this.onSearchItem(e)
    },
    gotocart () {
      this.$router.push('/cart')
      window.scrollTo(0, 0)
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.van-sidebar-item--select::before {
  background-color: rgb(53, 120, 229);
}
.van-tree-select__item--active {
  color: rgb(53, 120, 229);
}

.recomm-cell{
  border-radius:20px;
  padding-left: 10px !important;
  padding-right: 10px !important;
  padding-top: 0px !important;
  }
  .recomm-cell .van-grid >>>.van-grid-item__content {
  padding-top: 2px !important;
  padding-left: 8px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Result.vue